/**
 * Admin Provisioning Hook
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import * as service from './admin-provisioning.service'
import type { ProvisionInstitutionInput } from './admin-provisioning.service'

export function useProvisionInstitution() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: ProvisionInstitutionInput) => service.provisionInstitution(data),
    onSuccess: () => {
      // Invalida caches afectadas: lista de instituciones, KPIs, summary
      queryClient.invalidateQueries({ queryKey: ['institutions'] })
      queryClient.invalidateQueries({ queryKey: ['admin-dashboard'] })
    },
  })
}
